import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './SingleProfile.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class SIngleProfile extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.update = this.update.bind(this);
    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    

    public handleChange(key,rowData, e) {

        // set profile data

        console.log(rowData);

        const profileDataKey = 'Profiledata'

        if (key.indexOf(profileDataKey) > -1) {

            const actualKey = key.replace(profileDataKey, '').replace('.', '');

            console.log('found profile data', actualKey);

            rowData[profileDataKey][actualKey] = e.target.value;
        }

        else{
            rowData[key] = e.target.value;
        }

        this.forceUpdate();

        console.log(e.target.value);
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async update() {

        const state = this.state;

        const profile = state.data.profile;

        state.data.loaded = false;

       

        console.log(profile);

        const retVal = confirm("Do you want to continue ? Changes are permanent.");
    
        if(retVal === true) {

                  this.setState(state);
                  console.log('edit accepted');
                  const res = await this.props.services.adminAPI.updateSingleProfile(profile.UserProfileId, profile);
                  if (res.ok) {

                    toast.success('Profile updated successfully!');

                    state.data.profile = res.data;
                
                }

                else {
                    toast.error('Error updating profile!');
                }

                state.data.loaded = true;

                this.setState(state);

                return true;
        } else {
            console.log('edit canceled')
            return false;
        }
    }


    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: ProfileID } } = match;

      
        const profileRes = await adminAPI.getSingleProfile(ProfileID);

        if (profileRes.ok) {
            
            const profile = profileRes.data;

            this.setState(
                {
                     data: {
                        profile,
                        loaded: true
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
                
                <ContentRow>
                    <table>
                        <tbody>
                            <tr>
                                <td>Profile Name</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  disabled={true} value={data.profile.User} onChange= {(e) => this.handleChange('User', data.profile, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>User Level</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  disabled={true} value={data.profile.UserLevel} onChange= {(e) => this.handleChange('UserLevel', data.profile, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>Subscription ID</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  value={data.profile.SubscriptionId} onChange= {(e) => this.handleChange('SubscriptionId', data.profile, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>Plex Level</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  value={data.profile.PlexLevel} onChange= {(e) => this.handleChange('PlexLevel', data.profile, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>D.O.B</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  value={data.profile.Profiledata.dob} onChange= {(e) => this.handleChange('Profiledata.dob', data.profile, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>Field 1</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  value={data.profile.field_1} onChange= {(e) => this.handleChange('field_1', data.profile, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>Field 2</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  value={data.profile.field_2} onChange= {(e) => this.handleChange('field_2', data.profile, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>Field 3</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  value={data.profile.field_3} onChange= {(e) => this.handleChange('field_3', data.profile, e)} />
                                </td>
                            </tr>
 
                            <tr>
                                <td>Field 4</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  value={data.profile.field_4} onChange= {(e) => this.handleChange('field_4', data.profile, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>Field 5</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  value={data.profile.field_5} onChange= {(e) => this.handleChange('field_5', data.profile, e)} />
                                </td>
                            </tr>
                            
                            </tbody>
                    </table>

                    
                </ContentRow>

                <ContentRow>
 
                <Button  onClick={this.update}>Submit Changes</Button>
                    </ContentRow>

              </Content>

              
              </Wrapper>
        );

    }

}

export default withServices(SIngleProfile);


// WEBPACK FOOTER //
// ./src/pages/Admin/UserProfiles/SingleUserProfile/SingleProfile.tsx